import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import '../styles/courseDetail.css';

const CourseDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [course, setCourse] = useState(null);

  useEffect(() => {
    // Mock courses and videos data
    const mockCourses = [
      {
        id: 1,
        title: "Grit 1",
        description: "Learn the basics of HTML, CSS, and JavaScript",
        category: "Technology",
        level: "Beginner",
        duration: 40,
        progress: 65,
        enrolled: true
      },
      {
        id: 2,
        title: "AI AND PRACTICAL APPLICATIONS FOR AFRICA",
        description: "Master advanced React concepts and patterns",
        category: "Technology",
        level: "Advanced",
        duration: 60,
        progress: 30,
        enrolled: true
      }
    ];

    const foundCourse = mockCourses.find(c => c.id === parseInt(id));
    if (foundCourse) {
      setCourse(foundCourse);
    }
  }, [id]);

  if (!course) {
    return <div className="page" style={{ display: 'block' }}><div className="container"><p>Course not found</p></div></div>;
  }

  return (
    <div className="page" style={{ display: 'block' }}>
      <div className="container">
        <button 
          className="btn btn-secondary" 
          onClick={() => navigate('/courses')}
          style={{ marginBottom: 'var(--spacing-lg)', width: '40px', height: '40px', padding: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '6px', background: '#1a1a1a', color: 'white', border: 'none', cursor: 'pointer', transition: 'all 300ms ease' }}
          onMouseOver={(e) => {
            e.currentTarget.style.background = '#2d2d2d';
            e.currentTarget.style.transform = 'scale(1.05)';
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.background = '#1a1a1a';
            e.currentTarget.style.transform = 'scale(1)';
          }}
        >
          <i className="fas fa-arrow-left"></i>
        </button>
        
        <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: 'var(--spacing-2xl)' }}>
          {/* Main Content Area */}
          <div>
            <div style={{ borderLeft: '4px solid var(--color-accent)', paddingLeft: 'var(--spacing-lg)', marginBottom: 'var(--spacing-2xl)' }}>
              <h1 style={{ fontSize: '2rem', marginBottom: 'var(--spacing-md)' }}>{course.title}</h1>
              <p style={{ color: '#666', fontSize: '1.05rem', lineHeight: '1.6' }}>{course.description}</p>
            </div>

            {/* Video Section */}
            <div style={{ marginBottom: 'var(--spacing-2xl)' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--spacing-md)', marginBottom: 'var(--spacing-lg)' }}>
                <button
                  onClick={() => navigate('/courses')}
                  style={{
                    background: '#e8e8e8',
                    border: 'none',
                    color: '#1a1a1a',
                    padding: '0.6rem 0.8rem',
                    borderRadius: '6px',
                    cursor: 'pointer',
                    fontSize: '1.1rem',
                    transition: 'all 300ms ease'
                  }}
                  onMouseOver={(e) => {
                    e.target.style.background = '#d0d0d0';
                  }}
                  onMouseOut={(e) => {
                    e.target.style.background = '#e8e8e8';
                  }}
                >
                  <i className="fas fa-arrow-left"></i>
                </button>
                <h2 style={{ fontSize: '1.5rem', fontWeight: 700, display: 'flex', alignItems: 'center', gap: 'var(--spacing-md)', margin: 0 }}>
                  <i className="fas fa-video" style={{ color: 'var(--color-accent)' }}></i>
                  Course Videos
                </h2>
              </div>
            </div>

            {/* Quick Actions Section */}
            <div style={{ marginBottom: 'var(--spacing-2xl)' }}>
              <h2 style={{ fontSize: '1.5rem', marginBottom: 'var(--spacing-lg)', fontWeight: 700 }}>
                Quick Actions
              </h2>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 'var(--spacing-lg)' }}>
                {/* Take Tutorial */}
                <div
                  onClick={() => navigate(`/course/${course.id}/all-tutorials`)}
                  style={{
                    background: '#f9f9f9',
                    border: '2px solid #e8e8e8',
                    borderRadius: '8px',
                    padding: '2rem',
                    cursor: 'pointer',
                    transition: 'all 300ms ease',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '1rem',
                    textAlign: 'center'
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.boxShadow = '0 6px 16px rgba(0, 0, 0, 0.1)';
                    e.currentTarget.style.borderColor = '#1a1a1a';
                    e.currentTarget.style.backgroundColor = '#ffffff';
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.boxShadow = 'none';
                    e.currentTarget.style.borderColor = '#e8e8e8';
                    e.currentTarget.style.backgroundColor = '#f9f9f9';
                  }}
                >
                  <div style={{ flexShrink: 0 }}>
                    <i className="fas fa-graduation-cap" style={{
                      fontSize: '2rem',
                      color: '#7A5107'
                    }}></i>
                  </div>
                  <div>
                    <h3 style={{
                      fontSize: '1.1rem',
                      fontWeight: 700,
                      margin: '0',
                      color: '#1a1a1a'
                    }}>
                      Take Tutorial
                    </h3>
                    <p style={{
                      fontSize: '0.85rem',
                      color: '#666',
                      margin: '0.5rem 0 0 0'
                    }}>
                      View and watch available tutorial content
                    </p>
                  </div>
                </div>

                {/* Watch Videos */}
                <div
                  onClick={() => navigate(`/course/${course.id}/student-videos`)}
                  style={{
                    background: '#f9f9f9',
                    border: '2px solid #e8e8e8',
                    borderRadius: '8px',
                    padding: '2rem',
                    cursor: 'pointer',
                    transition: 'all 300ms ease',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '1rem',
                    textAlign: 'center'
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.boxShadow = '0 6px 16px rgba(0, 0, 0, 0.1)';
                    e.currentTarget.style.borderColor = '#1a1a1a';
                    e.currentTarget.style.backgroundColor = '#ffffff';
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.boxShadow = 'none';
                    e.currentTarget.style.borderColor = '#e8e8e8';
                    e.currentTarget.style.backgroundColor = '#f9f9f9';
                  }}
                >
                  <div style={{ flexShrink: 0 }}>
                    <i className="fas fa-video" style={{
                      fontSize: '2rem',
                      color: '#7A5107'
                    }}></i>
                  </div>
                  <div>
                    <h3 style={{
                      fontSize: '1.1rem',
                      fontWeight: 700,
                      margin: '0',
                      color: '#1a1a1a'
                    }}>
                      Watch Videos
                    </h3>
                    <p style={{
                      fontSize: '0.85rem',
                      color: '#666',
                      margin: '0.5rem 0 0 0'
                    }}>
                      Watch course videos released by your instructor
                    </p>
                  </div>
                </div>

                {/* Take Lab */}
                <div
                  onClick={() => navigate(`/course/${id}/all-labs`)}
                  style={{
                    background: '#f9f9f9',
                    border: '2px solid #e8e8e8',
                    borderRadius: '8px',
                    padding: '2rem',
                    cursor: 'pointer',
                    transition: 'all 300ms ease',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '1rem',
                    textAlign: 'center'
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.boxShadow = '0 6px 16px rgba(0, 0, 0, 0.1)';
                    e.currentTarget.style.borderColor = '#1a1a1a';
                    e.currentTarget.style.backgroundColor = '#ffffff';
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.boxShadow = 'none';
                    e.currentTarget.style.borderColor = '#e8e8e8';
                    e.currentTarget.style.backgroundColor = '#f9f9f9';
                  }}
                >
                  <div style={{ flexShrink: 0 }}>
                    <i className="fas fa-flask" style={{
                      fontSize: '2rem',
                      color: '#7A5107'
                    }}></i>
                  </div>
                  <div>
                    <h3 style={{
                      fontSize: '1.1rem',
                      fontWeight: 700,
                      margin: '0',
                      color: '#1a1a1a'
                    }}>
                      Take Lab
                    </h3>
                    <p style={{
                      fontSize: '0.85rem',
                      color: '#666',
                      margin: '0.5rem 0 0 0'
                    }}>
                      Access and download your lab materials
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* PDF Materials Section */}
            <div style={{ marginBottom: 'var(--spacing-2xl)', textAlign: 'center' }}>
              <button 
                className="btn btn-goldenrod" 
                style={{ width: 'auto', padding: '0.625rem 1.25rem', fontSize: '1rem' }}
                onClick={() => navigate(`/course/${course.id}/all-labs`)}
              >
                <i className="fas fa-book"></i> View More Labs
              </button>
            </div>
          </div>

          {/* Sidebar */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--spacing-lg)' }}>
            <div style={{ background: 'white', border: '1px solid var(--color-border)', borderRadius: '8px', padding: 'var(--spacing-lg)' }}>
              <button 
                className="btn"
                style={{ background: 'var(--color-accent)', color: 'white', border: 'none', padding: '1rem', fontWeight: 600, borderRadius: '6px', cursor: 'pointer', width: '100%', fontSize: '1rem', transition: 'all var(--transition)' }}
                onClick={() => navigate('/attendance')}
                onMouseOver={(e) => {
                  e.currentTarget.style.opacity = '0.9';
                  e.currentTarget.style.transform = 'translateY(-2px)';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.opacity = '1';
                  e.currentTarget.style.transform = 'translateY(0)';
                }}
              >
                <i className="fas fa-clipboard-check" style={{ marginRight: '0.5rem' }}></i>Take Attendance
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CourseDetail;
